import React, { useContext, useEffect, useState } from 'react';
import colorsObject from '../helpers/colorsObject';
import sizeObject from '../helpers/sizeObject';
import productObject from '../helpers/productObject';
import tagsArray from '../helpers/tagsArray';
import materialsArray from '../helpers/materialsArray';
import AppContext from '../context/AppContext';
import { setToken, postData, updateData } from '../services/request';
import './ItemsCadastry.css';

function ItemsCadastry() {

  const { selectedProduct, setSelectedProduct } = useContext(AppContext);
  const [isEditing, setIsEditing] = useState(false);

  const changeColor = (e) => {
    const { value } = e.target;
    if (e.target.type === 'checkbox' && e.target.checked === true) {
      const array = selectedProduct.colors;
      array.push(colorsObject[value]);
      const newProduct = {
        ...selectedProduct,
        colors: array,
      }
      setSelectedProduct(newProduct);
      e.target.style.accentColor = value;
    } else {
      const array = selectedProduct.colors.filter((color) => color !== colorsObject[value]);
      const newProduct = {
        ...selectedProduct,
        colors: array,
      }
      setSelectedProduct(newProduct);
    }
  };

  const changeTags = (e) => {
    const { value } = e.target;
    if (e.target.type === 'checkbox' && e.target.checked === true) {
      const array = selectedProduct.tags;
      array.push(value);
      const newProduct = {
        ...selectedProduct,
        tags: array,
      }
      setSelectedProduct(newProduct);
    } else {
      const array = selectedProduct.tags.filter((tag) => tag !== value);
      const newProduct = {
        ...selectedProduct,
        tags: array,
      }
      setSelectedProduct(newProduct);
    }
  };

  const changeGender = ({ target }) => {
    const { value } = target;
    if (target.checked === true) {
      const array = selectedProduct.gender;
      array.push(value);
      const newProduct = {
        ...selectedProduct,
        gender: array,
      }
      setSelectedProduct(newProduct);
    } else {
      const array = selectedProduct.gender.filter((tag) => tag !== value);
      const newProduct = {
        ...selectedProduct,
        gender: array,
      }
      setSelectedProduct(newProduct);
    }
  };

  const changeSize = ({ target }) => {
    const { name, value } = target;

    const newSize = {
      ...selectedProduct.size,
    };
    newSize[name] = Number(value);
    const newProduct = {
      ...selectedProduct,
      size: newSize,
    };
    newProduct.quantity = Object.values(newProduct.size).reduce((acc, item) => acc + item)
    setSelectedProduct(newProduct);
  };

  const changeThumbnail = ({ target }) => {
    const { name, value } = target;

    const newThumbs = value.split('\n');
    const newProduct = {
      ...selectedProduct,
      thumbs: newThumbs,
    }
    setSelectedProduct(newProduct);
  };

  const changeStatus = ({ target }) => {
    const newStatus = target.checked;
    const newProduct = {
      ...selectedProduct,
      status: newStatus,
    }
    setSelectedProduct(newProduct);
  };

  const changeDelivery = ({target}) => {
    const newDelivery = target.checked;
    const newProduct = {
      ...selectedProduct,
      promptDelivery: newDelivery,
    }
    setSelectedProduct(newProduct);
  }

  const changeMaterial = ({ target }) => {
    const newMaterial = target.value;
    const newProduct = {
      ...selectedProduct,
      material: newMaterial,
    }
    setSelectedProduct(newProduct);
  };

  const handleChange = (e) => {
    const { name } = e.target
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;

    switch (name) {
      case 'item-tag':
        changeTags(e);
        break;
      case 'item-color':
        changeColor(e);
        break;
      case 'gender':
        changeGender(e);
        break;
      case 'thumbnail':
        changeThumbnail(e);
        break;
      case 'status':
        changeStatus(e);
        break;
      case 'delivery':
        changeDelivery(e);
        break;
      default:
        const newProduct = {
          ...selectedProduct,
        }
        newProduct[name] = value;
        setSelectedProduct(newProduct);
        break;
    }
  };

  const createProduct = async () => {
    const userData = JSON.parse(sessionStorage.getItem('login'));
    const token = userData.token;

    await setToken(token);
    const newProduct = await postData('/clothes', selectedProduct);
    console.log(newProduct)
    setSelectedProduct(productObject);
    if (newProduct.name && newProduct.name.length > 0) {
      alert(`O produto ${newProduct.name} foi criado com a referência: ${newProduct.ref}`)
    }
  };

  const editProduct = async () => {
    const userData = JSON.parse(sessionStorage.getItem('login'));
    const token = userData.token;

    await setToken(token);
    console.log(`/clothes/${selectedProduct.id}`)
    await updateData(`/clothes/${selectedProduct.id}`, selectedProduct)
  }

  useEffect(() => {
    if (!selectedProduct.name) {
      setSelectedProduct(productObject);
    } else {
      setIsEditing(true);
    }
  }, []);

  const {
    oldReference,
    name,
    description,
    cost,
    supplier,
    manufacturer,
    cashPrice,
    buyDate,
    size,
    material,
    colors,
    gender,
    status,
    tags,
    thumbs,
    promptDelivery,
  } = selectedProduct

  const arrayToText = (arr = []) => {
    let string = ""
    for (let i = 0; i < arr.length; i += 1) {
      if (i < arr.length - 1) {
        string = string + arr[i] + "\n"
      } else {
        string = string + arr[i]
      }
    }
    return string
  }

  return (
    <main>
      <form className="form-cadastry">
        <fieldset className="form-section column">
          <legend>Dados gerais</legend>
          <label className="form-label" htmlFor="item-name">Nome</label>
          <input id="item-name" className="form-input" type="text" name="name" onChange={(e) => handleChange(e)} value={name} />
          <label className="form-label" htmlFor="item-description">Descrição</label>
          <textarea id="item-description" className="form-input-textarea" type="text" name="description" onChange={(e) => handleChange(e)} value={description} />
          <label className="form-label" htmlFor="item-old-reference">Referência Antiga</label>
          <input id="item-old-reference" className="form-input" type="text" name="oldReference" onChange={(e) => handleChange(e)} />
          <label className="form-label" htmlFor="item-cost">Custo</label>
          <input id="item-cost" className="form-input" type="number" name="cost" onChange={(e) => handleChange(e)} value={cost ? cost : ""} />
          <label className="form-label" htmlFor="item-cash">Preço à vista</label>
          <input id="item-cash" className="form-input" type="number" name="cashPrice" onChange={(e) => handleChange(e)} value={cashPrice ? cashPrice : ""} />
          <label className="form-label" htmlFor="item-supplier">Fornecedor</label>
          <input id="item-supplier" className="form-input" type="text" name="supplier" onChange={(e) => handleChange(e)} value={supplier} />
          <label className="form-label" htmlFor="item-manufacturer">Fabricante</label>
          <input id="item-manufacturer" className="form-input" type="text" name="manufacturer" onChange={(e) => handleChange(e)} value={manufacturer} />
          <label className="form-label" htmlFor="item-date">Data da compra</label>
          <input id="item-date" className="form-input" type="date" name="buyDate" onChange={(e) => handleChange(e)} value={buyDate ? buyDate.replace('T00:00:00.000Z', '') : ""} />
        </fieldset>
        <fieldset className="form-section">
          <legend>Dados específicos</legend>
          <label className="label-inline">
            M
            <input id="gender-male" className="form-check" type="checkbox" name="gender" value="masculino" onChange={(e) => handleChange(e)} checked={gender ? gender.includes("masculino") : false} />
          </label>
          <label className="label-inline">
            F
            <input id="gender-female" className="form-check" type="checkbox" name="gender" value="feminino" onChange={(e) => handleChange(e)} checked={gender ? gender.includes("feminino") : false} />
          </label>
          <fieldset>
            <legend>Quantidade</legend>
            {
              Object.keys(sizeObject).map((element) => (
                <label key={element} className="label-inline">
                  {sizeObject[element]}
                  <input
                    className="form-check-size"
                    type="number"
                    name={element}
                    onChange={(e) => changeSize(e)}
                    min="0"
                    value={size ? size[element] : 0}
                  />
                </label>
              ))
            }
          </fieldset>
          <fieldset className="colors-container">
            <legend>Cores</legend>
            {
              Object.keys(colorsObject).sort((a, b) => a - b).map((color) => (
                <label key={color} className="form-label">
                  {colorsObject[color]}
                  <input
                    className="form-check-color"
                    type="checkbox"
                    name="item-color"
                    value={color}
                    onChange={(e) => changeColor(e)}
                    checked={colors ? colors.includes(colorsObject[color]) : false}
                  />
                </label>
              ))
            }
          </fieldset>
          <fieldset className="colors-container">
            <legend>Tags</legend>
            {
              tagsArray.map((tag) => (
                <label key={tag}>
                  {tag}
                  <input
                    className="form-check-tag"
                    type="checkbox"
                    name="item-tag"
                    value={tag}
                    onChange={(e) => handleChange(e)}
                    checked={tags ? tags.includes(tag) : false}
                  />
                </label>
              ))
            }
          </fieldset>
          <fieldset className="colors-container">
            <legend>Material</legend>
            {
              materialsArray.map((element) => (
                <label key={element}>
                  {element}
                  <input
                    className="form-check-material"
                    type="radio"
                    name="item-material"
                    value={element}
                    onChange={(e) => changeMaterial(e)}
                    checked={material ? material.includes(element) : false}
                  />
                </label>
              ))
            }
          </fieldset>
          <fieldset>
            <legend>Imagens</legend>
            <label className="label-inline">
              Links
              <textarea
                className="form-input-textarea"
                type="text"
                name="thumbnail"
                onChange={(e) => handleChange(e)}
                value={arrayToText(thumbs)}
              />
            </label>
          </fieldset>
          <label>
            Liberado para venda?
            <input type="checkbox" name="status" onChange={(e) => handleChange(e)} checked={status} />
          </label>
          <br/>
          <label>
            Pronta entrega?
            <input type="checkbox" name="delivery" onChange={(e) => handleChange(e)} checked={promptDelivery} />
          </label>
        </fieldset>
        <div className="form-control-container">
          {
            !isEditing ? (
              <button type="button" onClick={createProduct} className="form-control">Criar</button>
            ) : (
              <button type="button" onClick={editProduct} className="form-control">Salvar</button>
            )
          }
        </div>
      </form>
    </main>
  )
}

export default ItemsCadastry